import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Select from '../../../../components/widgets/Select';
import selectCss from '../../../../components/widgets/ReactSelectOverrides.css';
import { CONDITION_TYPES } from '../../constants';
import { findOption } from '../../utils';
import css from './style.css';

const DimensionSelect = ({ dimension, disabled = false, betaHiddenFlags = {}, translate, editCondition }) => {
    const options = useMemo(
        () =>
            CONDITION_TYPES.filter(type => type.visible && !betaHiddenFlags[type.value])
                .map(type => ({ value: type.value, label: translate(type.labelKey) }))
                .sort((a, b) => a.label.localeCompare(b.label)),
        [betaHiddenFlags, translate]
    );

    return (
        <Select
            className={classNames(selectCss.singularSelect, css.conditionSelect)}
            classNamePrefix="Select"
            isDisabled={disabled}
            isClearable={false}
            isSearchable
            usePortal
            value={findOption(options, dimension)}
            options={options}
            onChange={option => option && editCondition('dimension', option.value)}
        />
    );
};

DimensionSelect.propTypes = {
    dimension: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    betaHiddenFlags: PropTypes.objectOf(PropTypes.bool),
    translate: PropTypes.func.isRequired,
    editCondition: PropTypes.func.isRequired,
};

export default DimensionSelect;
